import request from '@/utils/request'

// 登录
export const login = (data) => {
  return request.post('/admin/login', data)
}

// 退出登录
export const logout = () => {
  return request.post('/admin/logout')
}

// 获取登录态权限信息
export const getAuthInfo = () => {
  return request.get('/admin/auth/info')
}

// 谷歌验证器绑定 / 解绑
export const googleAuthBegin = () => request.post('/admin/me/google-auth/begin')
export const googleAuthConfirm = (data) => request.post('/admin/me/google-auth/confirm', data)
export const googleAuthUnbind = (data) => request.post('/admin/me/google-auth/unbind', data)

// 修改当前登录用户密码
export const changeMyPassword = (data) => request.post('/admin/me/change-password', data)
